import {NgModule} from "@angular/core";
import {DokumentDetaljerKomponentAvhengigheter} from "web-ng2/moduler/dokument/komponenter/dokument-detaljer/dokument-detaljer";
import {DokumentvisningKomponentAvhengigheter} from "web-ng2/moduler/dokument/komponenter/dokumentvisning/DokumentvisningKomponentAvhengigheter";

import {DokumentMenyKomponentAvhengigheter} from "web-ng2/moduler/dokument/komponenter/dokument-meny/dokument-meny";
import {DokumentTilSigneringStatusKomponentAvhengigheter} from "web-ng2/moduler/dokument/komponenter/dokument-til-signering-status/dokument-til-signering-status";
import {DokumentSendTilSigneringDialogKomponentAvhengigheter} from "web-ng2/moduler/dokument/modale/dokument-send-til-signering-dialog/dokument-send-til-signering-dialog";
import {DokumentRedigerTilSigneringDialogKomponentAvhengigheter} from "web-ng2/moduler/dokument/modale/dokument-rediger-til-signering-dialog/dokument-rediger-til-signering-dialog";
import {DokumentversjonListeKomponentAvhengigheter} from "web-ng2/moduler/dokument/komponenter/dokumentversjon-liste/dokumentversjon-liste";
import {AgendaDokumentValgDialogAvhengigheter} from "web-ng2/moduler/dokument/modale/agenda-dokument-valg-dialog/agenda-dokument-valg-dialog";
import {ForfalteOppgaverDokumentValgDialogAvhengigheter} from "web-ng2/moduler/dokument/modale/forfalte-oppgaver-dokument-valg-dialog/forfalte-oppgaver-dokument-valg-dialog";

@NgModule({
    providers: [
        DokumentDetaljerKomponentAvhengigheter,
        DokumentvisningKomponentAvhengigheter,
        DokumentMenyKomponentAvhengigheter,
        DokumentTilSigneringStatusKomponentAvhengigheter,
        DokumentSendTilSigneringDialogKomponentAvhengigheter,
        DokumentRedigerTilSigneringDialogKomponentAvhengigheter,
        DokumentversjonListeKomponentAvhengigheter,
        AgendaDokumentValgDialogAvhengigheter,
        ForfalteOppgaverDokumentValgDialogAvhengigheter
    ]
})
export class DokumentModul {

}
